import { EditIcon, SearchIcon, SmallCloseIcon } from "@chakra-ui/icons";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Textarea,
  useToast,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import ReactSearchBox from "react-search-box";

let wordLimit = 500;

const Showinfo = ({ lotNumber, dataReadyArray, bin }) => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [showData, setShowData] = useState(null);
  useEffect(() => {
    const searchForCategory = () => {
      const foundObject = dataReadyArray.find(
        (obj) => obj["lotno"] === lotNumber
      );
      const CaO = foundObject ? foundObject.CaO : undefined;
      const Cr = foundObject ? foundObject.Cr : undefined;
      const Cr2O3 = foundObject ? foundObject.Cr2O3 : undefined;
      const FC = foundObject ? foundObject.FC : undefined;
      const Fe2O3 = foundObject ? foundObject.Fe2O3 : undefined;
      const result = [
        { key: "CaO", value: CaO },
        { key: "Cr", value: Cr },
        { key: "Cr2O3", value: Cr2O3 },
        { key: "FC", value: FC },
        { key: "Fe2O3", value: Fe2O3 },
      ];

      return result;
    };
    setShowData(searchForCategory());
  }, []);
  // console.log(showData);
  return (
    <>
      <div
        className=" flex justify-center items-center gap-2 cursor-pointer"
        onClick={() => {
          onOpen();
        }}
      >
        <img src="svgs/infobutton.svg" alt="inf" />
      </div>

      <Modal isOpen={isOpen} onClose={onClose} isCentered="true">
        <ModalOverlay />
        <ModalContent h={"400px"} overflow={"scroll"} className="rounded">
          <div className=" flex justify-end p-2 text-[#79767D]  ">
            {" "}
            <SmallCloseIcon onClick={onClose} className="cursor-pointer" />
          </div>
          <ModalBody pos="relative" p="10px">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col relative gap-2">
                <p className="text-[#3E3C42] text-[14px] font-medium">
                  Chemistry : {bin} &nbsp;-{lotNumber}
                </p>
              </div>
            </div>

            {showData && (
              <div className="w-full mt-5 flex flex-col gap-4">
                {showData.map((item, index) => (
                  <div
                    key={index}
                    className="flex gap-2 w-full justify-between p-3"
                  >
                    <p className="text-[#79767D]">{item?.key}</p>
                    <p className="text-[#6CA6FC]">{item?.value?.toFixed(2)}</p>
                  </div>
                ))}
              </div>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Showinfo;
